import { notificationTypes } from '../../constants';
import modelUtils from '../../utils/model';
import actionTypes from './actionTypes';

const addId = (notification) => ({
    ...notification,
    id: modelUtils.guid(),
});

export const removeAllNotifications = () => ({
    type: actionTypes.REMOVE_ALL_NOTIFICATIONS,
});

export const removeNotification = (id) => ({
    type: actionTypes.NOTIFICATION_REMOVE,
    payload: id,
});

export const addNotification = (notification) => (dispatch) => {
    const newNotification = addId(notification);

    if (!newNotification.isPersistent) {
        setTimeout(() => dispatch(removeNotification(newNotification.id)), 5000);
    }

    dispatch({
        type: actionTypes.NOTIFICATION_ADD,
        payload: {
            ...newNotification,
        },
    });
};

export const notifyError = (error) => (dispatch) => {
    const message = typeof error === 'string' ? error : error.message;

    dispatch(
        addNotification({
            type: notificationTypes.ERROR,
            isPersistent: true,
            message,
        }),
    );
};

export const notifySuccess = (message) => (dispatch) => {
    dispatch(
        addNotification({
            type: notificationTypes.SUCCESS,
            isPersistent: false,
            message,
        }),
    );
};
